/* eslint-disable vue/no-use-v-if-with-v-for */ /* eslint-disable vue/no-unused-vars */
<template>
  <div
    class="grid"
    style="height: calc(100vh - 90px); overflow: auto; padding-bottom: 0"
    @scroll="loadData"
  >
    <div class="grid-title">
      <h4>{{ $t("MANAGE_SYNC_OTA") }}</h4>
    </div>
    <div class="grid-body p-3 border-top-unset d-flex">
      <v-progress-linear
        color="warning"
        :indeterminate="true"
        rounded
        height="3"
        v-if="isLoading"
      ></v-progress-linear>
      <v-row v-if="!isLoading">
        <v-col sm="3" class="pb-0">
          <v-btn
            color="primary"
            class="w-100"
            outlined
            medium
            @click="addNew()"
          >
            <v-icon color="#173d8f" small>add</v-icon>
            <label class="has-action fs-12">{{
              $t("ADD_NEW_SALE_CHANNEL")
            }}</label>
          </v-btn>
          <v-list dense>
            <v-list-item-group mandatory v-model="selectedItem" color="primary">
              <v-list-item
                v-for="(item, i) in listOTAConnected"
                :key="i"
                :value="item.id"
              >
                <v-list-item-content>
                  <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component -->
                  <v-list-item-title v-text="item.ota.otaI18n.find((x) => x.lang == defaultI18n).name">
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-icon :color="item.otaStatus ? 'primary ' : '#6d6d6d'"
                    >cloud_done</v-icon
                  >
                </v-list-item-icon>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-col>

        <v-col
          v-if="!isError && listOTAConnected.length > 0"
          sm="9"
          class="pb-0"
          style="border-left: 1px solid #cdcdcd"
        >
          <v-row align="center">
            <v-col sm="3">
              <label>{{ $t("HOTEL_CODE") }}</label>
            </v-col>
            <v-col sm="4">
              <div class="d-connect-detail text-dark">
                {{ conectedDetail.otaHotelCode }}
              </div>
            </v-col>
            <v-col class="text-right">
              <v-btn
                color="primary"
                small
                class="pr-10 pl-10"
                @click="$refs.disconnectOta.open()"
                :disabled="isLoading || isLoadingPopup"
              >
                <span class="fs-10">{{
                  conectedDetail.status ? $t("DISCONNECT") : $t("CONNECT")
                }}</span></v-btn
              >
              <v-btn
                color="success"
                small
                class="pr-10 pl-10 ml-2"
                @click="$refs.undo.open()"
                :disabled="isLoading || isLoadingPopup"
              >
                <span class="fs-10">{{ $t("UNDO") }}</span></v-btn
              >
            </v-col>
          </v-row>

          <v-row align="center" class="mt-0">
            <v-col sm="3">
              <label>{{ $t("CURRENCY_OTA") }}</label>
            </v-col>
            <v-col sm="4">
              <div class="d-connect-detail text-dark">
                {{ conectedDetail.currencyCode }}
              </div>
            </v-col>
          </v-row>
          <v-row align="center" class="mt-0">
            <v-col sm="3" class="pb-1">
              <label class="d-flex">{{ $t("SETUP_RATE_TYPE") }}
                <v-tooltip top nudge-right="200">
                  <template v-slot:activator="{ on, attrs }">
                    <i class="icon-info fs-18 ml-1 text-primary" v-bind="attrs"
                    v-on="on"></i>
                  </template>
                  <div class="fs-13" style="max-width: 400px" v-html="$t('TOOLTIP_INCLUDE_COMMISSION')"></div>
                </v-tooltip>
              </label>
            </v-col>
            <v-col sm="4" class="pb-1">
              <v-select
                ref="otaRoomSelect"
                :items="commissionList"
                item-text="text"
                item-value="value"
                v-model="commission.extra.includedCommission"
                dense
                outlined
                @change="updateExtra()"
                :disabled="isUpdateExtra"
              ></v-select>
            </v-col>
          </v-row>
          <i class="text-secondary mb-2 fs-10"> {{ $t("SETUP_RATE_TYPE_NOTE") }} </i>
          <v-row class="mt-0">
            <v-col sm="2">
              <label>{{ $t("ROOM_CLASS_MAPING") }}</label>
            </v-col>
            <v-col>
              <v-row class="mt-0">
                <v-col
                  sm="4"
                  v-for="(item, index) in conectedDetail.roomTypes"
                  class="py-0 pb-1 d-checkbox"
                  :title="
                    item.roomTypeI18n.find((e) => e.lang === defaultI18n).name
                  "
                  :key="`roomTypeList_${index}`"
                >
                  <v-checkbox
                    v-model="selectedRoomType"
                    :label="
                      item.roomTypeI18n.find((e) => e.lang === defaultI18n).name
                    "
                    :value="item.id"
                    class="mt-0"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <small class="text-danger">{{ $t("ROOM_TYPE_MAP_UNMAP") }}</small>
            </v-col>
          </v-row>
          <div class="mapping-roomtype">
            <v-row class="d-header-table mb-2">
              <v-col>
                <label class="font-weight-bold fs-12 text-dark">{{
                  $t("ROOM_TYPE_ON_CMS")
                }}</label>
              </v-col>
              <v-col>
                <label class="font-weight-bold fs-12 text-dark">{{
                  $t("ROOM_TYPE_ON_SABRE")
                }}</label>
              </v-col>
            </v-row>
            <template v-for="(item, i) in tmpRoomType">
              <v-row class="mt-0" :key="`tmpRoomType_row_1_${i}`">
                <v-col class="fs-12 d-flex align-items-center pt-0">
                  {{ item.roomTypeI18n.find((e) => e.lang === defaultI18n).name }}
                  ({{ $t("HOTEL_LOG_id") }}: {{ item.roomTypeCode }})</v-col
                >
                <v-col class="pt-0">
                  <v-select
                    ref="otaRoomSelect"
                    :items="availableOtaRoomList(item.otaRoomTypeCode)"
                    item-value="roomTypeCode"
                    v-model="item.otaRoomTypeCode"
                    dense
                    outlined
                    :placeholder="$t('ROOMTYPE')"
                    @change="validateRoomTypeCode(item.id)"
                    :no-data-text="$t('NO_DATA')"
                  >
                    <template v-slot:item="{ item }">
                      <span>{{ item.roomTypeName }} {{ item.roomTypeCode ? `(${item.roomTypeCode})` : '' }}</span>
                    </template>
                    <template v-slot:selection="{ item }">
                      <span>{{ item.roomTypeName }} {{ item.roomTypeCode ? `(${item.roomTypeCode})` : '' }}</span>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
              <v-row
                class="mt-0"
                v-if="item.ratePlans.length > 0"
                :key="`tmpRoomType_row_2_${i}`"
              >
                <v-col class="pt-0 pl-5">
                  <label class="font-weight-bold fs-12 text-dark">{{
                    $t("ROOM_PLAN_ON_CMS")
                  }}</label>
                </v-col>
                <v-col class="pt-0 pl-5">
                  <label class="font-weight-bold fs-12 text-dark">{{
                    $t("ROOM_PLAN_ON_SABRE")
                  }}</label>
                </v-col>
              </v-row>
              <v-row
                v-for="(plan, j) in item.ratePlans"
                class="mt-0"
                :key="`tmpRoomType_row_3_${i}_ratePlans_${j}`"
              >
                <v-col class="fs-12 d-flex align-items-center pt-0 pl-5">
                  {{ plan.ratePlanI18n.find((e) => e.lang === defaultI18n).name }}
                  ({{ $t("HOTEL_LOG_id") }}: {{ plan.ratePlanCode }})
                  <svg
                    style="margin-top: -4px; cursor: auto"
                    class="ml-1"
                    width="16px"
                    height="16px"
                    viewBox="-1.6 -1.6 19.20 19.20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    transform="rotate(0)"
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0">
                      <rect
                        x="-1.6"
                        y="-1.6"
                        width="19.20"
                        height="19.20"
                        rx="0"
                        fill="#ffffff"
                        strokewidth="0"
                      ></rect>
                    </g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke="#CCCCCC"
                      stroke-width="0.032"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <path
                        d="M8 7C9.65685 7 11 5.65685 11 4C11 2.34315 9.65685 1 8 1C6.34315 1 5 2.34315 5 4C5 5.65685 6.34315 7 8 7Z"
                        fill="#343a40"
                      ></path>
                      <path
                        d="M14 12C14 10.3431 12.6569 9 11 9H5C3.34315 9 2 10.3431 2 12V15H14V12Z"
                        fill="#343a40"
                      ></path>
                    </g>
                  </svg>
                  <span> {{ plan.guestCount }} </span>
                </v-col>
                <v-col class="pt-0 pl-5">
                  <v-select
                    :items="availableRatePlanList(item.otaRoomTypeCode, plan.otaPlanCode)"
                    v-model="plan.otaPlanCode"
                    item-value="ratePlanCode"
                    dense
                    outlined
                    :placeholder="$t('ROOMPLAN')"
                    :no-data-text="$t('NO_DATA')"
                  >
                    <template v-slot:item="{ item }">
                      <div style="display: flex; align-items: center">
                        <span>{{ item.ratePlanName }} {{ item.ratePlanCode ? `(${item.ratePlanCode})` : '' }}</span>
                        <template v-if="item.guestCount !== null">
                          <svg
                            style="margin-right: 8px"
                            width="16px"
                            height="16px"
                            viewBox="-1.6 -1.6 19.20 19.20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            class="m-0 ml-1"
                          >
                            <g id="SVGRepo_bgCarrier" stroke-width="0">
                              <rect
                                x="-1.6"
                                y="-1.6"
                                width="19.20"
                                height="19.20"
                                rx="0"
                                fill="#ffffff"
                                strokewidth="0"
                              ></rect>
                            </g>
                            <g
                              id="SVGRepo_tracerCarrier"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke="#CCCCCC"
                              stroke-width="0.032"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              <path
                                d="M8 7C9.65685 7 11 5.65685 11 4C11 2.34315 9.65685 1 8 1C6.34315 1 5 2.34315 5 4C5 5.65685 6.34315 7 8 7Z"
                                fill="#343a40"
                              ></path>
                              <path
                                d="M14 12C14 10.3431 12.6569 9 11 9H5C3.34315 9 2 10.3431 2 12V15H14V12Z"
                                fill="#343a40"
                              ></path>
                            </g>
                          </svg>
                          <span>{{ item.guestCount }}</span>
                        </template>
                      </div>
                    </template>
                    <template v-slot:selection="{ item }">
                      <div style="display: flex; align-items: center">
                        <span>{{ item.ratePlanName }} {{ item.ratePlanCode ? `(${item.ratePlanCode})` : '' }}</span>
                        <template v-if="item.guestCount !== null">
                          <svg
                            style="margin-right: 8px"
                            width="16px"
                            height="16px"
                            viewBox="-1.6 -1.6 19.20 19.20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            class="m-0 ml-1"
                          >
                            <g id="SVGRepo_bgCarrier" stroke-width="0">
                              <rect
                                x="-1.6"
                                y="-1.6"
                                width="19.20"
                                height="19.20"
                                rx="0"
                                fill="#ffffff"
                                strokewidth="0"
                              ></rect>
                            </g>
                            <g
                              id="SVGRepo_tracerCarrier"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke="#CCCCCC"
                              stroke-width="0.032"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                              <path
                                d="M8 7C9.65685 7 11 5.65685 11 4C11 2.34315 9.65685 1 8 1C6.34315 1 5 2.34315 5 4C5 5.65685 6.34315 7 8 7Z"
                                fill="#343a40"
                              ></path>
                              <path
                                d="M14 12C14 10.3431 12.6569 9 11 9H5C3.34315 9 2 10.3431 2 12V15H14V12Z"
                                fill="#343a40"
                              ></path>
                            </g>
                          </svg>
                          <span>{{ item.guestCount }}</span>
                        </template>
                      </div>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
              <v-divider :key="`tmpRoomType_row_4_${i}`"></v-divider>
            </template>
          </div>
          <div
            v-if="loadingMore"
            class="text-center py-2"
            style="position: sticky; left: 0"
          >
            <v-progress-circular
              :width="2"
              color="gray"
              indeterminate
            ></v-progress-circular>
          </div>
          <div class="text-right">
            <v-btn
              class="mr-3"
              v-if="
                listOTAConnected.find((e) => e.id === selectedItem).otaStatus
              "
              outlined
              color="primary"
              @click="
                syncData(
                  listOTAConnected.find((e) => e.id === selectedItem).ota.id
                )
              "
              :disabled="isLoading || isLoadingPopup"
            >
              {{ $t("SYNC") }}
            </v-btn>
            <v-btn
              color="primary"
              class="pr-10 pl-10"
              @click="checkBeforeUpdate()"
              :disabled="isLoading || isLoadingPopup"
            >
              {{ $t("MAP") }}</v-btn
            >
          </div>
        </v-col>
        <v-col
          v-if="listOTAConnected.length === 0"
          sm="9"
          class="pb-0"
          style="border-left: 1px solid #cdcdcd"
        >
          <v-row>
            <v-col sm="12" class="text-center">
              <v-icon style="height: 100%; font-size: 150px" color="#fed12f"
                >warning</v-icon
              >
            </v-col>
            <v-col sm="12">
              <p class="text-center">
                {{ $t("ACCOUNT_IS_NOT_CONNECTED_TO_TRAVELOKA") }}
                <br />
                {{ $t("CANNOT_GET_INFO_FROM_OTA_2") }}
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>

    <v-dialog v-model="popupAddNew" width="500">
      <v-card class="popup-add-new-channel">
        <template v-if="!isStep2">
          <v-autocomplete
            item-text="text"
            item-value="value"
            :items="listSelectOTA"
            :label="$t('SELECT_SALE_CHANNEL')"
            dense
            outlined
            v-model="selectedOTA"
          >
            <template slot="no-data">
              <div class="no-data">{{ $t("NO_DATA") }}</div>
            </template>
          </v-autocomplete>

          <div class="instruction" v-html="descriptionOTA"></div>
          <div class="instruction text-danger fs-10" v-if="errNullSelect">
            {{ errNullSelect }}
          </div>

          <v-divider></v-divider>

          <div class="text-center">
            <v-btn color="primary" @click="step2()">
              {{ $t("CONNECT") }}
            </v-btn>
          </div>
        </template>
        <template v-if="isStep2">
          <v-form ref="formValidate" lazy-validation>
            <loading
              :active.sync="isLoadingPopup"
              :is-full-page="false"
            ></loading>
            <v-row>
              <v-col class="pt-0 pb-0">
                <label>{{ $t("HOTEL_CODE") }}</label>
                <v-text-field
                  dense
                  outlined
                  v-model="otaHotelCode"
                  :rules="[rules.required]"
                  :placeholder="$t('HOTEL_CODE')"
                  @keydown="validateData"
                  @input="validatePaste"
                  :key="`otaHotelCodeCount_${otaHotelCodeCount}`"
                  ref="otaHotelCode"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="connect()">
                {{ $t("CONNECT") }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </template>
      </v-card>
    </v-dialog>
    <confirm-dialog
      @deleteItem="disconnect"
      :maxWidth="325"
      ref="disconnectOta"
    >
      <span slot="title"
        >{{
          conectedDetail.status
            ? $t("CONFIRM_DISCONNECT_OTA")
            : $t("CONFIRM_CONNECT_OTA")
        }}?</span
      >
    </confirm-dialog>
    <confirm-dialog @deleteItem="undo" :maxWidth="559" ref="undo">
      <span slot="title">{{ $t("CONFIRM_UNDO") }}?</span>
    </confirm-dialog>
    <confirm-dialog @deleteItem="update" :maxWidth="559" ref="confirmSave">
      <span slot="title">{{ $t("CONFIRM_SAVE") }}</span>
    </confirm-dialog>
    <v-dialog v-model="isNotMatchGuestCountDialog" :max-width="450">
      <v-toolbar class="toolbar-update" dense >
        <v-toolbar-title class="text-primary fs-15">
          <strong>{{$t('NOTIFICATION')}}</strong>
        </v-toolbar-title>
      </v-toolbar>
      <div class="content-update">
        <label class="s-label">
          <div class="font-weight-bold">{{$t('NOT_MATCH_GUEST_COUNT')}}</div>
          <div class="ml-2" v-for="(item, ind) in notMatchGuestList" :key="`roomRateList_${ind}`">- {{item}}</div>
        </label>
        <div class="mt-1 d-flex justify-content-end">
          <v-btn @click="()=> isNotMatchGuestCountDialog = false">
            {{ $t("CLOSE") }}
          </v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<style lang="scss">
.description-price {
  padding: 10px;
  p {
    margin-bottom: 2px;
    span {
      font-weight: bold;
    }
  }
}
.main-table {
  width: 100%;
}
.main-table td > span {
  font-size: 14px !important;
}
.d-checkbox {
  .v-input__slot {
    align-items: flex-start !important;
    label {
      overflow: hidden;
      display: -webkit-box !important;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      /* autoprefixer: off */
    }
  }
}
</style>

<script>
import { REGEX_NUMBER } from "@/_helpers/constant.js";
import { _alert } from "@/_helpers/function.js";
import { syncota } from "@/_services/SyncOTA/syncota.js";
import moment from "moment";
import ConfirmDialog from "@/components/Utils/ConfirmDialog.vue";

export default {
  components: {
    "confirm-dialog": ConfirmDialog,
  },
  data() {
    return {
      rules: {
        required: (value) =>
          (!!value && value.length > 0) || this.$t("_VALIDATE.REQUIRED"),
      },
      sysLang: this.$i18n.locale,
      popupAddNew: false,
      isLoading: false,
      dataAllOTA: [],
      listSelectOTA: [],
      listOTAConnected: [],
      selectedItem: 0,
      descriptionOTA: "",
      selectedOTA: "",
      isStep2: false,
      idOTA: "",
      conectedDetail: "",
      conectedDetailBefore: "",
      isLoadingPopup: false,
      form: {},
      isError: false,
      connectionType: null,
      otaCode: null,
      currentSubView: null,
      errNullSelect: null,
      otaExternalRoomTypeIds: [],
      otaHotelCode: null,
      selectedRoomType: [],
      selectedRoomTypeBefore: [],
      selectedRatePlanBefore: [],
      roomType: [],
      tmpRoomType: [],
      perPage: 0,
      itemPerPage: 5,
      totalPage: 0,
      loadingMore: false,
      otaRoomList: [],
      otaHotelCodeCount: 0,
      isNotMatchGuestCountDialog: false,
      notMatchGuestList: [],
      commission: {
        id: null,
        extra: ''
      },
      isUpdateExtra: false,
    };
  },
  computed: {
    commissionList() {
      if (!this.otaCode) return [];
      return [
        { text: this.$t('INCLUDE_COMMISSION'), value: true },
        { text: this.$t('EXCLUDE_COMMISSION'), value: false },
        { text: this.$t('UNDEFINED_COMMISSION'), value: -1 }
      ];
    },
    REGEX_NUMBER() {
      return REGEX_NUMBER;
    },
    roomTypeIds() {
      const arr = this.conectedDetail.otaRoomType.map((x) => {
        if (this.otaExternalRoomTypeIds.includes(x.otaRoomTypeCode)) {
          return x.roomType.id;
        } else return null;
      });
      var newArr = [];
      newArr = arr.filter(function (item) {
        return newArr.includes(item) ? "" : newArr.push(item);
      });
      return newArr.filter((e) => e !== null);
    },
    RatePlanIds() {
      const arr = this.conectedDetail.otaRatePlan.map((x) => {
        return x.ratePlan.id;
      });
      return arr.filter((e) => e !== null);
    },
    occupancyRoomIds() {
      const arr = this.conectedDetail.otaOccupancies.map((x) => {
        return x.roomType.id;
      });
      return arr.filter((e) => e !== null);
    },
    checkReSync() {
      return !this.deepObjectEqual(
        this.selectedRoomTypeBefore,
        this.selectedRoomType
      ) || !this.deepObjectEqual(this.conectedDetailBefore, this.conectedDetail)
        ? false
        : true;
    },
  },
  created() {
    this.initialize();
  },
  watch: {
    selectedOTA(value) {
      if (value) {
        this.errNullSelect = null;
      }
      // this.descriptionOTA = this.dataAllOTA.find(
      //   (x) => x.id == value
      // ).instructionVi;
      const foundOTA = this.dataAllOTA.find((x) => x.id == value);
      if (foundOTA) {
        const otaI18n = foundOTA.otaI18n.find((y) => y.lang == this.defaultI18n);
        this.descriptionOTA = otaI18n ? otaI18n.description : "";
      } else {
        this.descriptionOTA = "";
      }
      this.connectionType = this.dataAllOTA.find(
        (x) => x.id == value
      ).connectionType;

      this.otaCode = this.dataAllOTA.find((x) => x.id == value).otaCode;
      this.form = {};
      this.form = Object.assign(
        this.form,
        JSON.parse(this.dataAllOTA.find((x) => x.id == value).credentialsVi)
      );
    },
    selectedItem(value) {
      // Lấy thông tin chi tiết đồng bộ của 1 kênh
      this.isLoading = true;
      this.isError = false;
      this.conectedDetail = "";
      this.conectedDetailBefore = "";

      syncota
        .detailSyncOTATraveloka(value)
        .then((res) => {
          if (res.responseCode === 0) {
            this.conectedDetail = res.data;
            //không cho hiển thị hạng phòng con
            const roomTypes = this.conectedDetail.roomTypes.filter((room) => !room.hasParent);
            this.conectedDetail.roomTypes = roomTypes;

            this.commission.id = res.data.id;
            let extra = res.data.extra || JSON.stringify({includedCommission: true});
            extra = JSON.parse(extra);
            if (!extra.hasOwnProperty("includedCommission")) {
              extra.includedCommission = true;
            }
            extra.includedCommission = extra.includedCommission == null ? -1 : extra.includedCommission;
            this.commission.extra = extra;
            this.conectedDetailBefore = JSON.parse(JSON.stringify(this.conectedDetail));
            if (res.data.otaExternalRoomType) {
              this.otaExternalRoomTypeIds =
                this.conectedDetail.otaExternalRoomType.map((x) => {
                  return x.id;
                });
            }
            this.selectedRoomType = [];
            this.selectedRoomTypeBefore = [];
            this.selectedRatePlanBefore = [];

            this.conectedDetail.roomTypes.forEach((x) => {
              if (x.otaRoomTypeCode) {
                this.selectedRoomType.push(x.id);
                this.selectedRoomTypeBefore.push(x.id);

                x.ratePlans.forEach(plan => {
                  if (plan.otaPlanCode) {
                    this.selectedRatePlanBefore.push(plan.id);
                  }
                });
              }
            });
            this.otaCode = this.listOTAConnected.find(
              (e) => e.id === value
            ).otaCode;
          } else {
            if (res.data == "OTA_CONNECTION_ERROR") {
              this.isError = true;
            } else {
              _alert(res, this.$t(res.data), false);
            }
          }
        })
        .finally(() => (this.isLoading = false));

      syncota.getOTARoomTraveloka(this.idOTA).then((res) => {
        if (res.responseCode === 0) {
          const newItem = { roomTypeName: this.$t("SELECT_ROOM_TYPE"), roomTypeCode: null };
          this.otaRoomList = [newItem, ...res.data];
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });
    },
    selectedRoomType(value) {
      this.roomType = this.conectedDetail.roomTypes.filter((e) =>
        this.selectedRoomType.includes(e.id)
      );
      this.totalPage = Math.ceil(this.roomType.length / this.itemPerPage);
      this.perPage = 0;
      this.tmpRoomType = this.roomType.slice(
        this.perPage * this.itemPerPage,
        (this.perPage + 1) * this.itemPerPage
      );
      this.perPage += 1;
    },
  },
  methods: {
    updateExtra() {
      this.isUpdateExtra = true;
      const data = JSON.parse(JSON.stringify(this.commission));
      data.extra.includedCommission = data.extra.includedCommission != -1 ? data.extra.includedCommission : null;
      data.extra = JSON.stringify(data.extra);
      syncota
        .updateExtraTraveloka(data)
        .then((res) => {
          _alert(res, this.$t(res.data), false);
        }).finally(() => {
          this.isUpdateExtra = false;
        });
    },
    checkValidateMap() {
      this.notMatchGuestList = [];
      const response = {
        isDeleteRoomOrRate: false,
        isNotMatchGuestCount: false,
        listRoomRateErrors: []
      };

      const hasRemovedRoom = this.selectedRoomTypeBefore.some(
        roomId => !this.selectedRoomType.includes(roomId)
      );

      if (hasRemovedRoom) {
        response.isDeleteRoomOrRate = true;
      }
      
      const oldSelectedRoomType = this.roomType.filter(room => this.selectedRoomTypeBefore.includes(room.id) && this.selectedRoomType.includes(room.id));
      for (let room of oldSelectedRoomType) {
        if (!room.otaRoomTypeCode) {
          response.isDeleteRoomOrRate = true;
          continue;
        }
        const otaRatePlans = this.otaRoomList.find(e => room.otaRoomTypeCode == e.roomTypeCode).ratePlans;
        for (let plan of room.ratePlans) {
          const isTargetPlan = this.selectedRatePlanBefore.includes(plan.id);
          if (!plan.otaPlanCode) {
            if (isTargetPlan) response.isDeleteRoomOrRate = true;
            continue;
          }
          const guestCount = otaRatePlans.find(e => plan.otaPlanCode == e.ratePlanCode).guestCount;
          if (plan.guestCount != guestCount) {
            const roomName = room.roomTypeI18n.find((e) => e.lang === this.defaultI18n).name;
            const ratePlanName = plan.ratePlanI18n.find((e) => e.lang === this.defaultI18n).name;
            response.isNotMatchGuestCount = true;
            response.listRoomRateErrors.push(this.$t("ROOM_RATE_TYPE", {room: roomName, rate: ratePlanName}));
          }
        }
      }
      
      //xử lý với đối tượng thêm mới.
      const newRoomMap = this.selectedRoomType.filter(
        item => !this.selectedRoomTypeBefore.includes(item)
      );

      if (newRoomMap.length > 0) {
        const otherRoomType = this.roomType.filter((room) => newRoomMap.includes(room.id));
        for (let room of otherRoomType) {
          if (!room.otaRoomTypeCode) continue;
          
          const otaRatePlans = this.otaRoomList.find(e => room.otaRoomTypeCode == e.roomTypeCode).ratePlans;
          for (let plan of room.ratePlans) {
            if (!plan.otaPlanCode) {
              continue;
            }

            const guestCount = otaRatePlans.find(e => plan.otaPlanCode == e.ratePlanCode).guestCount;
            if (plan.guestCount != guestCount) {
              const roomName = room.roomTypeI18n.find((e) => e.lang === this.defaultI18n).name;
              const ratePlanName = plan.ratePlanI18n.find((e) => e.lang === this.defaultI18n).name;
              response.isNotMatchGuestCount = true;
              response.listRoomRateErrors.push(this.$t("ROOM_RATE_TYPE", {room: roomName, rate: ratePlanName}));
            }
          }
        }
      }
      this.notMatchGuestList = response.listRoomRateErrors;

      return response;
    },
    validateData($event) {
      let key = $event.key;
      if (key === " ") {
        $event.preventDefault();
      }
    },
    validatePaste() {
      const newData = this.otaHotelCode.replace(/\s/g, "");
      this.otaHotelCode = newData;
      this.otaHotelCodeCount++;
      this.$nextTick(() => {
        if (this.$refs.otaHotelCode) {
          this.$refs.otaHotelCode.focus();
        }
      });
    },
    availableOtaRoomList(roomTypeCode) {
      const selectedRoomTypeCodes = new Set(
        this.roomType
        .map(rt => rt.otaRoomTypeCode)
        .filter(code => typeof code === 'string' && code.trim() !== '')
      );
      return this.otaRoomList.filter(
        room => room.roomTypeCode === null || !selectedRoomTypeCodes.has(room.roomTypeCode) || room.roomTypeCode == roomTypeCode
      );
    },
    availableRatePlanList(otaRoomTypeCode, otaPlanCode) {
      if (!otaRoomTypeCode) return [];
      const matchedRoomType = this.roomType.find(
        (e) => e.otaRoomTypeCode === otaRoomTypeCode
      );
      if (!matchedRoomType) return [];
      const selectedRatePlanCodes = new Set(
        matchedRoomType.ratePlans
          .map((plan) => plan.otaPlanCode)
          .filter((code) => typeof code === 'string' && code.trim() !== '')
      );
      const otaRoom = this.otaRoomList.find(
        (room) => room.roomTypeCode === otaRoomTypeCode
      );
      if (!otaRoom || !Array.isArray(otaRoom.ratePlans) || otaRoom.ratePlans.length === 0) {
        return [];
      }
      const availablePlans = otaRoom.ratePlans.filter(
        (plan) =>
          !selectedRatePlanCodes.has(plan.ratePlanCode) ||
          plan.ratePlanCode === otaPlanCode
      );
      const defaultOption = {
        guestCount: null,
        ratePlanCode: null,
        ratePlanName: this.$t('SELECT_SALE_PACKAGE'),
      };
      if (availablePlans.length == 0) return [];
      return [defaultOption, ...availablePlans];
    },
    validateRoomTypeCode(roomId, ratePlanId = null) {
      const changedRoom = this.tmpRoomType.find((room) => room.id === roomId) || null;
      if (!changedRoom) return;
      //xoá hết otaPlanCode
      changedRoom.ratePlans.forEach((plan) => {
        plan.otaPlanCode = null;
      });
    },
    loadData(event) {
      if (this.loadingMore) {
        return;
      }
      const table = event.target;
      const scrollTop = table.scrollTop;
      const clientHeight = table.clientHeight;
      const scrollHeight = table.scrollHeight;
      if (
        scrollHeight - scrollTop - clientHeight <= 100 &&
        this.perPage < this.totalPage
      ) {
        this.loadingMore = true;
        setTimeout(() => {
          this.tmpRoomType = [
            ...this.tmpRoomType,
            ...this.roomType.slice(
              this.perPage * this.itemPerPage,
              (this.perPage + 1) * this.itemPerPage
            ),
          ];
          this.perPage += 1;
          this.loadingMore = false;
        }, 1000);
      }
    },
    async syncData(id) {
      this.isLoading = true;
      await syncota.travelokaSyncData(id).then((res) => {
        _alert(res, this.$t(res.data), false);
      }).finally(() => (this.isLoading = false));
    },
    undo() {
      location.reload();
    },
    findDuplicates(arr, type) {
      let array = [];
      if (type === "ROOM") {
        array = arr.map((item) => item.otaRoomTypeCode).filter((e) => e);
      } else {
        array = arr.map((item) => item.otaPlanCode).filter((e) => e);
      }
      return array.filter((item, index) => array.indexOf(item) != index);
    },
    async initialize() {
      this.isLoading = true;
      let body = {
        keyword: "",
        status: 1,
      };
      await syncota.getAllOTANotConnectTraveloka(body).then((res) => {
        if (res.responseCode === 0) {
          this.dataAllOTA = res.data;
          this.listSelectOTA = res.data.map((x) => {
            return {
              value: x.id,
              text: x.otaI18n.find((y) => y.lang == this.defaultI18n).name,
            };
          });
          this.listSelectOTA = this.listSelectOTA.filter((x) => x.value);

          this.listSelectOTA.sort(function (a, b) {
            var nameA = a.text.toLowerCase(),
              nameB = b.text.toLowerCase();
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
          });
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });

      await syncota.getConnectedOTATraveloka(body).then((res) => {
        if (res.responseCode === 0) {
          this.listOTAConnected = res.data;
          if (this.listOTAConnected.length > 0) {
            this.selectedItem = this.listOTAConnected[0].id;
            this.idOTA = this.listOTAConnected[0].ota.id;
          } else {
            this.isLoading = false;
          }
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });
    },
    addNew() {
      this.popupAddNew = true;
    },
    checkBeforeUpdate() {
      const response = this.checkValidateMap();
      if (response.isNotMatchGuestCount) {
        this.isNotMatchGuestCountDialog = true;
        return false;
      }

      if (response.isDeleteRoomOrRate) {
        this.$refs.confirmSave.open();
      } else {
        this.update();
      }
    },
    update() {
      this.isLoading = true;
      this.conectedDetail.roomTypes.forEach((e) => {
        if (!this.selectedRoomType.includes(e.id)) {
          e.otaRoomTypeCode = null;
          e.ratePlans.forEach((i) => {
            i.otaPlanCode = null;
          });
        }
      });
      let connectSaving = this.conectedDetail.roomTypes;
      syncota
        .updateDetailSyncOTATraveloka(
          connectSaving,
          this.listOTAConnected.find((e) => e.id === this.selectedItem).ota.id
        )
        .then((res) => {
          _alert(res, this.$t(res.data), true);
        })
        .finally(() => (this.isLoading = false));
    },
    step2() {
      if (this.selectedOTA) {
        if (this.connectionType == 3) {
          this.connect();
          // Nếu chọn thêm mới BE
        } else if (
          this.connectionType == 1 &&
          (this.otaCode == "EZ_BE" || this.otaCode == "EZ_GOOGLE_HOTEL")
        ) {
          this.connect();
          // Đóng popup thêm mới
          this.popupAddNew = false;
        } else {
          this.isStep2 = true;
        }
      } else {
        this.errNullSelect = this.$t("CHANNEL_EMPTY");
      }
    },
    connect() {
      let isValidFrom = this.$refs.formValidate.validate();
      if (!isValidFrom) {
        return;
      }
      let body = {
        ota: {
          id: this.selectedOTA,
        },
        otaHotelCode: this.otaHotelCode,
      };
      this.isLoadingPopup = true;
      syncota
        .createConnectOTATraveloka(body)
        .then((res) => {
          if (res.responseCode == 0) {
            _alert(res, this.$t(res.data), true);
          } else {
            _alert(res, this.$t(res.data), false);
          }
        })
        .finally(() => (this.isLoadingPopup = false));
    },
    disconnect() {
      this.isLoadingPopup = true;
      syncota
        .disconnectOTATraveloka(
          this.listOTAConnected.find((e) => e.id === this.selectedItem).ota.id
        )
        .then((res) => {
          _alert(res, this.$t(res.data), true);
        })
        .finally(() => (this.isLoadingPopup = false));
    },
    viewDetail(i) {
      this.currentSubView = i;
    },
    _moment: moment,
  },
};
</script>